import React from 'react';
import { Player } from '../../domain/entities';
import { Modal } from '../shared/Modal';
import './PlayerDetailModals.css';

const negotiationOptions = [
    { label: '-20%', multiplier: 0.8 }, { label: '-10%', multiplier: 0.9 },
    { label: 'As Is', multiplier: 1.0 }, { label: '+10%', multiplier: 1.1 },
    { label: '+20%', multiplier: 1.2 }
];

interface ContractRenewalModalProps {
    player: Player | null;
    onClose: () => void;
    onConfirm: () => void;
    message: { type: 'success' | 'error', text: string } | null;
    isSubmitting: boolean;
    selectedWageMultiplier: number;
    onWageMultiplierChange: (multiplier: number) => void;
    selectedContractLength: number;
    onContractLengthChange: (length: number) => void;
}

export const ContractRenewalModal: React.FC<ContractRenewalModalProps> = ({ 
    player, onClose, onConfirm, message, isSubmitting, 
    selectedWageMultiplier, onWageMultiplierChange, 
    selectedContractLength, onContractLengthChange 
}) => {
    if (!player) return null;

    return (
        <Modal isOpen={!!player} onClose={onClose}>
            <h2>Renew Contract for {player.name}</h2>
            {message && <p className={message.type === 'success' ? 'positive' : 'error'}>{message.text}</p>}
            
            <div className="negotiation-group">
                <h4>Propose New Weekly Wage</h4>
                <p>Current Wage: £{player.wage.toLocaleString()}/wk</p>
                <ul className="negotiation-options">
                    {negotiationOptions.map(({ label, multiplier }) => (
                        <li key={label}>
                            <button 
                                className={`button ${selectedWageMultiplier === multiplier ? 'primary' : ''}`}
                                onClick={() => onWageMultiplierChange(multiplier)}
                            >
                                <span>{label} ({`£${Math.round(player.wage * multiplier).toLocaleString()}/wk`})</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="negotiation-group">
                <h4>Propose Contract Length</h4>
                <ul className="negotiation-options">
                    {[1, 2, 3, 4, 5].map(years => (
                        <li key={years}>
                            <button
                                className={`button ${selectedContractLength === years ? 'primary' : ''}`}
                                onClick={() => onContractLengthChange(years)}
                            >
                                {years} Year{years > 1 ? 's' : ''}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            
            <div className="modal-actions">
                <button className="button" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                <button className="button primary" onClick={onConfirm} disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Submit Offer'}</button>
            </div>
        </Modal>
    );
};
